const config = {
    API_URL: "https://jadara.online/api/api/v1",
    //API_URL: "http://127.0.0.1:3000/api/v1",
};

export default config;
